import featureToggleApiFactory from '../../modules/feature-toggle/featureToggleApi'

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils'

/* Actions */
import {
  getDesktopHomePageFeatureTogglesActionCreators,
  getMobileHomePageFeatureTogglesActionCreators,
  getMobileSearchFeatureTogglesActionCreators,
  getDesktopSearchFeatureTogglesActionCreators,
  getMobileCategoryPageFeatureTogglesActionCreators,
  getDesktopCategoryPageFeatureTogglesActionCreators,
  getAppFeatureTogglesActionCreators,
  getSearchOldFeatureTogglesActionCreators,
  getDesktopTagPageFeatureTogglesActionCreators,
  getMobileTagPageFeatureTogglesActionCreators,
  getCampaignFeatureTogglesActionCreators,
  getDynamicFeatureTogglesActionCreators,
  getDynamicViewFeatureTogglesActionCreators,
  getStaticFeatureTogglesActionCreators,
  getBrandFeatureTogglesActionCreators,
  getMobileProductDetailFeatureTogglesActionCreators,
  getDesktopProductDetailFeatureTogglesActionCreators,
  getAuthorsFeatureTogglesActionCreators,
  getMerchantPageFeatureTogglesActionCreators,
  getProductQnaFeatureTogglesActionCreators,
  getProductCommentFeatureTogglesActionCreators, getNotFoundPageFeatureTogglesActionCreators
} from '../actions/featureToggleActions'

function featureToggleSagasFactory({storefrontApiClient}) {
  const featureToggleApi = featureToggleApiFactory(storefrontApiClient)

  const getDesktopHomePageFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDesktopHomePageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDesktopHomePageFeatureToggles', cacheStatus: true},
  )

  const getMobileHomePageFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getMobileHomePageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getMobileHomePageFeatureToggles', cacheStatus: true},
  )

  const getMobileSearchFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getMobileSearchFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getMobileSearchFeatureToggles', cacheStatus: true},
  )

  const getDesktopSearchFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDesktopSearchFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDesktopSearchFeatureToggles', cacheStatus: true},
  )

  const getDesktopTagPageFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDesktopTagPageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDesktopTagPageFeatureToggles', cacheStatus: true},
  )

  const getMobileTagPageFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getMobileTagPageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getMobileTagPageFeatureToggles', cacheStatus: true},
  )

  const getSearchOldFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getSearchOldFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getSearchOldFeatureToggles', cacheStatus: true},
  )

  const getMobileCategoryPageFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getMobileCategoryPageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getMobileCategoryPageFeatureToggles', cacheStatus: true},
  )

  const getDesktopCategoryPageFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDesktopCategoryPageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDesktopCategoryPageFeatureToggles', cacheStatus: true},
  )

  const getAppFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getAppFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getAppFeatureToggles', cacheStatus: true},
  )

  const getCampaignFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getCampaignFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getCampaignFeatureToggles', cacheStatus: true},
  )

  const getDynamicFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDynamicFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDynamicFeatureToggles', cacheStatus: true},
  )

  const getDynamicViewFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDynamicViewFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDynamicViewFeatureToggles', cacheStatus: true},
  )

  const getStaticFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getStaticFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getStaticFeatureToggles', cacheStatus: true},
  )

  const getBrandFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getBrandFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getBrandFeatureToggles', cacheStatus: true},
  )

  const getMobileProductDetailFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getMobileProductDetailFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getMobileProductDetailFeatureToggles', cacheStatus: true},
  )

  const getDesktopProductDetailFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getDesktopProductDetailFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getDesktopProductDetailFeatureToggles', cacheStatus: true},
  )

  const getProductCommentFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getProductCommentFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getProductCommentFeatureToggles', cacheStatus: true},
  )

  const getProductQnaFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getProductQnaFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getProductQnaFeatureToggles', cacheStatus: true},
  )

  const getAuthorsFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getAuthorsFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getAuthorsFeatureToggles', cacheStatus: true},
  )

  const getMerchantFeatureTogglesSaga = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getMerchantPageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getMerchantFeatureToggles', cacheStatus: true},
  )

  const getNotFoundFeatureTogglesSagas = generateDefaultAsyncSaga(
    featureToggleApi.getFeatureToggles,
    getNotFoundPageFeatureTogglesActionCreators,
    payload => [
      payload.params,
    ],
    {cacheKey: 'getNotFoundPageFeatureToggles', cacheStatus: true},
  )

  const watchGetDesktopHomePageFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DESKTOP_HOME_PAGE_FEATURE_TOGGLES',
    getDesktopHomePageFeatureTogglesSaga,
  )
  const watchGetMobileHomePageFeatureToggles = generateDefaultAsyncWatcher(
    'GET_MOBILE_HOME_PAGE_FEATURE_TOGGLES',
    getMobileHomePageFeatureTogglesSaga,
  )
  const watchGetMobileSearchFeatureToggles = generateDefaultAsyncWatcher(
    'GET_MOBILE_SEARCH_FEATURE_TOGGLES',
    getMobileSearchFeatureTogglesSaga,
  )
  const watchGetDesktopSearchFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DESKTOP_SEARCH_FEATURE_TOGGLES',
    getDesktopSearchFeatureTogglesSaga,
  )
  const watchGetDesktopTagPageFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DESKTOP_TAG_PAGE_FEATURE_TOGGLES',
    getDesktopTagPageFeatureTogglesSaga,
  )
  const watchGetMobileTagPageFeatureToggles = generateDefaultAsyncWatcher(
    'GET_MOBILE_TAG_PAGE_FEATURE_TOGGLES',
    getMobileTagPageFeatureTogglesSaga,
  )
  const watchGetSearchOldFeatureToggles = generateDefaultAsyncWatcher(
    'GET_SEARCH_OLD_FEATURE_TOGGLES',
    getSearchOldFeatureTogglesSaga,
  )
  const watchGetMobileCategoryPageFeatureToggles = generateDefaultAsyncWatcher(
    'GET_MOBILE_CATEGORY_PAGE_FEATURE_TOGGLES',
    getMobileCategoryPageFeatureTogglesSaga,
  )
  const watchGetDesktopCategoryPageFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DESKTOP_CATEGORY_PAGE_FEATURE_TOGGLES',
    getDesktopCategoryPageFeatureTogglesSaga,
  )
  const watchGetAppFeatureToggles = generateDefaultAsyncWatcher(
    'GET_APP_FEATURE_TOGGLES',
    getAppFeatureTogglesSaga,
  )
  const watchGetCampaignFeatureToggles = generateDefaultAsyncWatcher(
    'GET_CAMPAIGN_FEATURE_TOGGLES',
    getCampaignFeatureTogglesSaga,
  )
  const watchGetDynamicFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DYNAMIC_FEATURE_TOGGLES',
    getDynamicFeatureTogglesSaga,
  )
  const watchGetDynamicViewFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DYNAMIC_VIEW_FEATURE_TOGGLES',
    getDynamicViewFeatureTogglesSaga,
  )
  const watchGetStaticFeatureToggles = generateDefaultAsyncWatcher(
    'GET_STATIC_FEATURE_TOGGLES',
    getStaticFeatureTogglesSaga,
  )
  const watchGetBrandFeatureToggles = generateDefaultAsyncWatcher(
    'GET_BRAND_FEATURE_TOGGLES',
    getBrandFeatureTogglesSaga,
  )
  const watchGetMobileProductDetailFeatureToggles = generateDefaultAsyncWatcher(
    'GET_MOBILE_PRODUCT_DETAIL_FEATURE_TOGGLES',
    getMobileProductDetailFeatureTogglesSaga,
  )
  const watchGetDesktopProductDetailFeatureToggles = generateDefaultAsyncWatcher(
    'GET_DESKTOP_PRODUCT_DETAIL_FEATURE_TOGGLES',
    getDesktopProductDetailFeatureTogglesSaga,
  )
  const watchGetAuthorsFeatureToggles = generateDefaultAsyncWatcher(
    'GET_AUTHORS_FEATURE_TOGGLES',
    getAuthorsFeatureTogglesSaga,
  )
  const watchGetMerchantFeatureToggles = generateDefaultAsyncWatcher(
    'GET_MERCHANT_PAGE_FEATURE_TOGGLES',
    getMerchantFeatureTogglesSaga,
  )
  const watchGetProductCommentFeatureToggles = generateDefaultAsyncWatcher(
    'GET_PRODUCT_COMMENT_FEATURE_TOGGLES',
    getProductCommentFeatureTogglesSaga,
  )
  const watchGetProductQnaFeatureToggles = generateDefaultAsyncWatcher(
    'GET_PRODUCT_QNA_FEATURE_TOGGLES',
    getProductQnaFeatureTogglesSaga,
  )
  const watchGetNotFoundFeatureToggles = generateDefaultAsyncWatcher(
    'GET_NOT_FOUND_PAGE_FEATURE_TOGGLES',
    getNotFoundFeatureTogglesSagas,
  )

  const featureToggleSagas = [
    watchGetDesktopHomePageFeatureToggles(),
    watchGetMobileHomePageFeatureToggles(),
    watchGetMobileSearchFeatureToggles(),
    watchGetDesktopSearchFeatureToggles(),
    watchGetMobileCategoryPageFeatureToggles(),
    watchGetDesktopCategoryPageFeatureToggles(),
    watchGetAppFeatureToggles(),
    watchGetSearchOldFeatureToggles(),
    watchGetDesktopTagPageFeatureToggles(),
    watchGetMobileTagPageFeatureToggles(),
    watchGetCampaignFeatureToggles(),
    watchGetDynamicFeatureToggles(),
    watchGetDynamicViewFeatureToggles(),
    watchGetStaticFeatureToggles(),
    watchGetBrandFeatureToggles(),
    watchGetMobileProductDetailFeatureToggles(),
    watchGetDesktopProductDetailFeatureToggles(),
    watchGetAuthorsFeatureToggles(),
    watchGetMerchantFeatureToggles(),
    watchGetProductQnaFeatureToggles(),
    watchGetProductCommentFeatureToggles(),
    watchGetNotFoundFeatureToggles()
  ]

  return featureToggleSagas
}

export default featureToggleSagasFactory
